import { gql } from 'apollo-angular';

export const HARDCODED_REPORTS_QUERY = gql`
  query hardcodedReports {
    hardcodedReports {
      id
      reportName
      description
    }
  }
`;

export const PREVIOUS_GENERATED_HARDCODED_REPORTS_QUERY = gql`
  query previousGeneratedReport($id: String!) {
    hardcodedReports(id: $id) {
      id
      generatedHardcodedReports(previous: true) {
        id
        reportCsv
        generationStatus
      }
    }
  }
`;

export const GENERATED_HARDCODED_REPORTS_QUERY = gql`
  query generatedHardcodedReports($id: String!) {
    generatedHardcodedReports(id: $id) {
      id
      reportCsv
      generationStatus
    }
  }
`;

export const GENERATE_HARDCODED_REPORT_MUTATION = gql`
  mutation generateHardcodedReport($id: String!) {
    generateHardcodedReport(hardcodedReportId: $id) {
      hardcodedReport {
        id
      }
    }
  }
`;
